export { PersonalisationMessageConnected as PersonalisationMessage } from './container';
